function init_importer() {
    var $ = jQuery.noConflict();
    $.squdeAjaxPopup({
        url: '/import/wizard',
        secured: true,
        onOpen: function (elm, popup) {

            elm.find('.import-info-wrapper').hide();

            elm.attr('data-options','close_on_background_click:false;close_on_esc:false;');
            elm.attr('data-close-on-click','false');
        }
    });
    return false;
}
function readcsv(elm, sentFile) {
    var $ = jQuery.noConflict();
    var container = elm.parents('.reveal');
    container.isLoading();
    var table = container.find('.import-table-wrapper').find('table');
    table.empty();
    var file = sentFile,read = new FileReader();

    read.readAsText(file, 'UTF-8');

    read.onloadend = function(){
        var rows = read.result.split("\n");
        //alert(rows[59]);
        var field_names = [];
        var new_rows = [];



        rows.forEach(function(row, i) {
            row = row.split(';"').join(';').split('";').join(';');
            if(row.indexOf('"') >= 0) {
                var parts = row.split('"');
                for(var ii in parts) {
                    var part = parts[ii];
                    if(ii & 1) {
                        //Odd (1,3,5)
                        parts[ii] = part.split(';').join(':');
                    }
                }
                row = parts.join('"');
            }
            row = row.split('""').join('"');
            var p = row.split(';');
            console.log({p});
            if(p.length != row.length) {
                table.append('<tr></tr>');
                var tr = table.find('tr:last');
                p.forEach(function(col) {
                    if(i == 0) {
                        field_names = p;
                        tr.append('<th>'+col+'</th>');
                    } else {
                        tr.append('<td>'+col+'</td>');
                    }
                });
                new_rows.push(row);
            }
        });

        rows = new_rows;







        container.find('select#type_of_file').unbind('change').change(function() {
            var v = $(this).val();
            var fields_table = container.find('table.what-is-what');
            fields_table.find('tr:not(:nth-child(1))').remove();

            $.get('/import/getFields', {table: v}, function(data) {
                field_names.forEach(function(import_field_name, i) {
                    var tr = fields_table.find('tr:first');
                    if(i > 0) {
                        tr.clone(true,true).appendTo(fields_table);
                        tr = fields_table.find('tr:last');
                    }
                    tr.find('.import-field-name').html(import_field_name);

                    var sel = tr.find('select');
                    if(i == 0) {
                        sel.empty();
                        for(var key in data) {
                            var field_name = data[key];
                            sel.append('<option value="'+key+'">'+field_name+'</option>');
                        }
                    }
                    sel.find('option').each(function() {
                        if($(this).html() == import_field_name) {
                            sel.val($(this).attr('value'));
                        }
                    });
                })
            });

        }).trigger('change');


        var rows_done = [];
        var data_to_inputs = function() {
            var data_wrapper = container.find('.data-wrapper');
            data_wrapper.empty();
            var max_rows_per_save = 20;
            var rows_counter = 0;
            for (var i in rows) {
                var row = rows[i];
                var p = row.split(';');
                var added = false;
                p.forEach(function (col) {
                    if (i == 0) {
                        data_wrapper.append('<input type="hidden" name="field_names[]" value="' + col.trim() + '" />');
                    } else if (rows_done.indexOf(i) == -1) {
                        data_wrapper.append('<textarea style="display: none;" name="import_data[' + (i - 1) + '][]">' + col.trim() + '</textarea>');
                        added = true;
                    }
                });
                if (i > 0 && added === true) {
                    rows_done.push(i);
                    rows_counter++;
                    if (rows_counter == max_rows_per_save) {
                        break;
                    }
                }
            }
        };


        data_to_inputs();

        var progress_wrapper = container.find('h1').find('.progress-wrapper');

        container.find('form').bind('submit.scrollToTop', function() {
            $(this).unbind('submit.scrollToTop');
            $('.reveal-overlay').animate({'scrollTop':0},100);
            progress_wrapper.html('<br />0%');
        });

        container.find('form').ajaxFormSubmit(function(data, form){
            if(data == 1) {
                //If import was succesfull, check if you've had everything, else run save_data again!
                if(rows_done.length == rows.length -1) {
                    container.doneLoading();
                    squde_flash("Import geslaagd!");
                    progress_wrapper.html('<br />100%');
                    rows_done = [];
                    check_logs();
                } else {
                    var perc = Math.round(rows_done.length / (rows.length - 1) * 100);
                    progress_wrapper.html('<br />'+perc+'%');
                    data_to_inputs();
                    setTimeout(function() {
                        form.submit();
                    },500);
                }
            } else {
                check_logs();
            }

        }.bind([container]), function(xhr, status, error) {
            console.log(xhr,status,error);
            container.doneLoading();
            squde_flash("Er ging iets mis bij het importeren.", "alert");
            check_logs();
        }.bind([container]), function() {
            container.isLoading('dark');
        });





        container.find('.import-info-wrapper').show();
        container.doneLoading();
    }
}
function check_logs() {
    var $ = jQuery.noConflict();
    $.get('/import/getLogCount',function(data) {
        if(data > 0) {
            window.location.replace("/import/getLogFile");
        }
    });

}